const state = {
  id: null,
  name: '',
  entityType: 'serviceJob',
  filterStart: '',
  filterEnd: '',
  services: [],
  serviceJobStatuses: [],
  clients: [],
  users: [],
  serviceUsers: [],
  classifications: [],
  accountManagers: [],
  serviceDateFilterStart: '',
  serviceDateFilterEnd: '',
}

export const requiredFields = [
  { key: 'name' },
]

export default state
